<nz-layout>
  <nz-sider nzCollapsible [(nzCollapsed)]="isCollapsed" [nzTrigger]="null" [ngClass]="{'hidden-sidebar': isCollapsed}">
    <app-sidebar [isCollapsed]="isCollapsed" userType="admin"></app-sidebar>
  </nz-sider>

  <nz-layout>
    <nz-header>
      <span
        class="trigger"
        nz-icon
        [nzType]="isCollapsed ? 'menu-unfold' : 'menu-fold'"
        (click)="toggleSidebar()"
      ></span>
    </nz-header>

    <nz-content>
      <div class="inner-content">
        <router-outlet></router-outlet>
      </div>
    </nz-content>
  </nz-layout>
</nz-layout>
